// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"ef9c7e11","589":"c81b075b","787":"6a9ffc95"}[chunkId] + ".chunk.js";
};